/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OWGameSteamDataSupportInfo
 */
export interface OWGameSteamDataSupportInfo {
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamDataSupportInfo
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof OWGameSteamDataSupportInfo
     */
    email?: string;
}

export function OWGameSteamDataSupportInfoFromJSON(json: any): OWGameSteamDataSupportInfo {
    return OWGameSteamDataSupportInfoFromJSONTyped(json, false);
}

export function OWGameSteamDataSupportInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWGameSteamDataSupportInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function OWGameSteamDataSupportInfoToJSON(value?: OWGameSteamDataSupportInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'email': value.email,
    };
}


